import { render, staticRenderFns } from "./festivals.vue?vue&type=template&id=9e026e30&scoped=true"
import script from "./festivals.vue?vue&type=script&lang=js"
export * from "./festivals.vue?vue&type=script&lang=js"
import style0 from "./festivals.vue?vue&type=style&index=0&id=9e026e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e026e30",
  null
  
)

export default component.exports